export const S = {
    searchPopup: document.querySelector('.js-popup-search'),

    init: () => {
        const searchBtns = document.querySelectorAll('.js-toggle-popup-search');

        if (searchBtns && searchBtns.length > 0) {
            searchBtns.forEach(s => s.addEventListener('click', () => S.togglePopupSearch()));
        }

        S.initSearchInDropdownMenus();
    },

    togglePopupSearch: () => {
        S.searchPopup.classList.toggle('d-none');
        document.body.classList.toggle('overflow-hidden');

        // Class for animation
        setTimeout(() => {
            S.searchPopup.classList.toggle('is-visible');
        }, 10);
    },

    initSearchInDropdownMenus: () => {
        const searchDropdownMenus = document.querySelectorAll('.js-filter-dropdown-search');
        
        if (searchDropdownMenus && searchDropdownMenus.length > 0) {
            searchDropdownMenus.forEach(menu => {
                const searchInput = menu.querySelector('.js-filter-dropdown-search-input');
                const items = menu.querySelectorAll('.blog-page__option');

                if (!items || items.length === 0) {
                    console.error('Items non disponibles dans l\'event listener');
                    return;
                }
                
                if (searchInput) {
                    searchInput.addEventListener('input', () => {
                        const searchTerm = searchInput.value.toLowerCase();

                        items.forEach((item) => {
                            const label = item.querySelector('.blog-page__option-label');
                            const text = label ? label.textContent.toLowerCase() : '';

                            if (text.includes(searchTerm)) {
                                item.classList.remove('d-none');
                                item.style.display = '';
                            } else {
                                item.classList.add('d-none');
                                item.style.display = 'none';
                            }
                        });
                    });
                } 
            });
        }
    }
}